<!--
  - Copyright (c) 2020, Matthew T. Kaufman
  -->



<style>
.theme--light.v-icon {
    color: unset;
}

.xcell {
    color: transparent;
    transition: .2s;
}
.xcell:hover {
    color: lawngreen;
}

</style>

<template>
    <v-container>
        <v-data-table
                :headers="activityHeaders"
                :items="activityList"
                disable-pagination
                disable-sort
                hide-default-footer
                dense
                :loading="activityLoading"
                class="elevation-1"
        >
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.time.hour | hourTranslate }}</td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[0])" @click="onPlayback(row.item.time.channel, row.item.time.hour)"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[1])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (5*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[2])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (10*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[3])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (15*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[4])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (20*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[5])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (25*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[6])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (30*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[7])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (35*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[8])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (40*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[9])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (45*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[10])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (50*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                    <td class="xcell" :style="activityStyle(row.item.time.activityPercentage[11])" @click="onPlayback(row.item.time.channel, row.item.time.hour + (55*60))"><v-icon class="play">mdi-play-circle-outline</v-icon></td>
                </tr>
            </template>

        </v-data-table>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import * as d3 from 'd3-scale'
    import EventBus from '../event-bus';


    export default {
        props: {
            source: String
        },

        mounted: function () {
            EventBus.$on('reload',  () => {
                this.loadData();
            });
        },
        created() {
            console.log("DCR");
            this.loadData();
        },
        watch: {
            $route() {
                console.log("DW");
                this.loadData();
            }
        },
        computed: {
            styler() {
                return d3.scalePow().exponent(.3).range(["gray","red"])
            }
        },
        methods: {

            activityStyle(percentage) {
                if(percentage < 0)
                    return { "background-color" : "lightgray"}
                else
                    return { "background-color" : this.styler(percentage) }
                }
            ,
            loadData() {
              this.onChannelChange(this.$route.params.channel)
            },
            onChannelChange(channel)  {
                console.log("OCC " + channel )
                this.activityLoading = true;
                var after;
                var before;
                var dateValue = this.$store.getters.date
                console.log("retrieved date value "+dateValue)
                if (dateValue.length === 10) {
                    after = moment(dateValue)
                    before = after.clone().add(1, 'days').subtract(1, 'second')
                } else {
                    var today = moment().format('YYYY-MM-DD')
                    after = moment(today).subtract(2, 'days')
                    before = moment(today).add(1, 'days').subtract(1, 'second')
                }
                // console.log("after "+after.toISOString()+" before "+before.toISOString())
                this.$axios
                    .get("/activityindex/" + channel + "?after=" + after.unix() + "&before=" + before.unix())
                    .then(response => {
                        this.activityList = response.data;
                        this.activityLoading = false;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            onPlayback(channel, time) {
              this.$emit("playback", channel, time);
            }
        },
        filters: {
            hourTranslate(val) {
                return moment.unix(val).format('ddd M/D/YYYY HH:')
            }
        },
        data: () => ({
            activityLoading: null,
            activityList: [],
            activityHeaders: [
                {text: "Hour"},
                {text: ":00-:04"},
                {text: ":05-:09"},
                {text: ":10-:14"},
                {text: ":15-:19"},
                {text: ":20-:24"},
                {text: ":25-:29"},
                {text: ":30-:34"},
                {text: ":35-:39"},
                {text: ":40-:44"},
                {text: ":45-:49"},
                {text: ":50-:54"},
                {text: ":55-:59"}

            ]
        })
    };
</script>
